import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../shared/Breadcrumbs";
import { StaqContactRoute } from "../../routing/IndividualRoutes";

export class StaqContactPage extends Component {
  render() {
    return (
      <Fragment>
        <Breadcrumbs />
        <StaqContactRoute />
      </Fragment>
    );
  }
}
